import { ElementType } from 'react';

import dateService from '@gem/services/date-service';

import { DEFAULT_DEVICE_PROJECT_NAME } from '../Device.constants';
import { IDevice, IDeviceSession } from '../Device.types';

export interface IDeviceDetailsProps {
  className?: string;
  device: IDevice;
  deviceSession: IDeviceSession;
  projectName?: string;
  onCopiedToClipboard?: (message: string) => void;
  badgeIcon?: ElementType;
}

interface IDeviceDetailsPresenterParams
  extends Omit<IDeviceDetailsProps, 'className' | 'onCopiedToClipboard'> {}

interface IDeviceDetailsPresenter {
  lastActivity: string | null;
  appName: string;
  deviceOS: string;
  deviceName: string;
}

export function useDeviceDetailsPresenter(
  params: IDeviceDetailsPresenterParams
): IDeviceDetailsPresenter {
  const { device, deviceSession, projectName = DEFAULT_DEVICE_PROJECT_NAME } = params;
  const presenter: IDeviceDetailsPresenter = {
    get lastActivity(): string | null {
      return dateService.format(deviceSession.lastActivityTs, {
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      });
    },

    get appName(): string {
      return `${projectName} ${device.appVersion}`;
    },

    get deviceOS(): string {
      const filteredDeviceDetails = [device.osName, device.osVersion].filter(Boolean);
      if (!filteredDeviceDetails.length) {
        return '';
      }
      return filteredDeviceDetails.join(' ');
    },

    get deviceName(): string {
      return device.device;
    },
  };

  return presenter;
}
